import { render, staticRenderFns } from "./Conflicts.vue?vue&type=template&id=771f1359&lang=pug"
import script from "./Conflicts.vue?vue&type=script&lang=js"
export * from "./Conflicts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports